export default {
  product: 'club1',
  title: 'Club #1',
  apiProdUrl: 'https://clubone.uno:9999/api',
  apiDevUrl: 'http://localhost:8621/api',
  botProdUsername: 'clubnumberone_bot',
  botDevUsername: 'clubonedev_bot',
}